<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="criteresRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('addNewRelance.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('addNewRelance.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto
      is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="criteresRecherche.dates"
            :label="$t('addNewRelance.filtre.datePrevPaiement')">
          </input-periode>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="criteresRecherche.datesFacture"
            :label="$t('addNewRelance.filtre.dateFacture')">
          </input-periode>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="criteresRecherche.datesLastRelance"
            :label="$t('addNewRelance.filtre.dateLastRelance')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addNewRelance.filtre.noDateLastRelance')">
            <b-select v-model="criteresRecherche.noDateLastRelance">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addNewRelance.filtre.niveauDerniereRelance')">
            <b-select
              v-model="criteresRecherche.niveauDerniereRelance">
              <option :value="null"></option>
              <option
                v-for="(niveau, index) in constantes.NIVEAU_RELANCES"
                :key="index"
                :value="niveau.code">
                {{ $t(niveau.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('addNewRelance.filtre.commercial')"
                        v-model="commercialSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="payeursSelected"
            :disabled="isFromClient"
            :societeActiveId="societeActiveId"
            :label="$t('addNewRelance.filtre.payeur')">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0" v-if="modulePresseActive">
          <b-field :label="$t('addNewRelance.filtre.produits')">
            <qd-taginput
              v-model="produitsSelected"
              icon="magnify"
              :data="filteredProduits"
              autocomplete
              type="is-primary"
              :loading="isFetchingProduits"
              field="reference"
              @typing="getfilteredProduits">
              <template slot-scope="props">
                {{ props.option.reference }} - {{ props.option.libelle }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingProduits">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addNewRelance.filtre.comptesComptables')">
            <qd-taginput type='is-primary' v-model="criteresRecherche.comptesComptables">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addNewRelance.filtre.modeReglement')">
            <qd-taginput v-if="modeReglementTags"
                        v-model="modeReglementSelected"
                        :data="modeReglementTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredModeReglementTags"
                        @input="getModeReglementTag">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
                      :label="$t('listeCollectivite.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="criteresRecherche.agenceIdFacture">
          </agence-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addNewRelance.filtre.blocageReglement')">
            <b-select v-model="criteresRecherche.blocageReglement">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addNewRelance.filtre.nePasRelancer')">
            <b-select v-model="criteresRecherche.nePasRelancer">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false">
                {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('addNewRelance.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('addNewRelance.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche from '@/services/relances/genererCritereRechercheRetard';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import { getAll as getAllProduits } from '@/api/produit/index';
import {
  CATEGORIE_SALON, CATEGORIE_SPONSORING, CATEGORIE_AUTRE, CATEGORIE_PRESSE,
} from '@/configuration/catalogue/produitConf';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { NIVEAU_RELANCES } from '@/configuration/relances/relancesConf';
import { get as getClient } from '@/api/tiers';

const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  components: {
    userTagInput,
    errorMsgComponent,
    queryClientTagInput,
    agenceTagInput,
    inputPeriode,
  },
  props: {
    isFromClient: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      errors: [],
      criteresRecherche: null,
      clientPayeur: null,
      listeCommercial: [],
      commercialSelected: [],
      payeursSelected: [],
      produitsSelected: [],
      isFetchingProduits: false,
      filteredProduits: [],
      constantes: {
        NIVEAU_RELANCES,
      },
      listeModeReglementBase: [],
      modeReglementSelected: [],
      modeReglementTags: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...CategorieVente.mapGetters({
      categorieProduitByCode: 'categorieProduitByCode',
    }),
    storeName() {
      return this.isFromClient ? 'retardPaiementClient' : 'retardPaiement';
    },
    criteresRechercheBase: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE`, value);
      },
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    blocageFiltreCommercial() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return this.user.profil === COMMERCIAL;
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    modesReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    setCritereRecherche(value) {
      this.$store.commit(`${this.storeName}/SET_CRITERE_RECHERCHE`, value);
    },
    getfilteredProduits: debounce(async function getProduits(search) {
      this.filteredProduits = [];
      if (!search) return;
      this.isFetchingProduits = true;
      const categories = [CATEGORIE_SALON, CATEGORIE_SPONSORING, CATEGORIE_AUTRE, CATEGORIE_PRESSE]
        .filter(categorieCode => {
          return this.categorieProduitByCode.includes(categorieCode);
        });
      try {
        const produits = (await getAllProduits(
          {
            query: {
              auto: search,
              categorie: categories,
            },
          },
        )).data.result.items;
        this.filteredProduits = produits.filter((produit) => {
          return !this.produitsSelected.map(
            produitSelected => produitSelected.id,
          ).includes(produit.id);
        });
        this.isFetchingProduits = false;
      } catch (e) {
        this.isFetchingProduits = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    async viderCritere() {
      this.criteresRecherche = cloneDeep(genererCritereRecherche({
        clientPayeur: this.clientPayeur,
      }));
      await updateCritereWithParametreInterne(this.criteresRecherche);
      this.commercialSelected = this.criteresRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      this.payeursSelected = this.clientPayeur ? [this.clientPayeur] : [];
      this.produitsSelected = [];
      this.modeReglementSelected = [];
      this.getModeReglementTag();
    },
    appliquerCritere() {
      this.errors = [];
      if ((this.criteresRecherche.dates.dateFin
        && this.criteresRecherche.dates.dateDebut
           > this.criteresRecherche.dates.dateFin)
        || (this.criteresRecherche.datesFacture.dateFin
        && this.criteresRecherche.datesFacture.dateDebut
           > this.criteresRecherche.datesFacture.dateFin)) {
        this.errors.push({
          message: 'addNewRelance.filtre.errorDate',
        });
        return;
      }
      this.criteresRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.criteresRecherche.modesReglementsIds = this.modeReglementSelected
        .map((modeReglement) => {
          return modeReglement.id;
        });
      this.criteresRecherche.produits = this.produitsSelected;
      this.criteresRecherche.payeurs = this.payeursSelected;
      this.setCritereRecherche(this.criteresRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        await this.loadParametres([typesParametres.PARAMETRES_KEYS.modeReglement]);
        this.criteresRecherche = cloneDeep(this.criteresRechercheBase);
        await updateCritereWithParametreInterne(this.criteresRecherche);
        const users = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);

        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL]);

        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.criteresRecherche.commercialId.includes(c.id);
        });
        this.payeursSelected = this.criteresRecherche.payeurs;
        this.produitsSelected = this.criteresRecherche.produits;
        this.listeModeReglementBase = this.modesReglement;
        if (this.criteresRecherche.modesReglementsIds.length > 0) {
          this.modeReglementSelected = this.listeModeReglementBase.filter((modeReglemnt) => {
            return this.criteresRecherche.modesReglementsIds.includes(modeReglemnt.id);
          });
        }
        this.getModeReglementTag();
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getModeReglementTag() {
      this.modeReglementTags = this.listeModeReglementBase.filter((modeReglement) => {
        return !this.modeReglementSelected.map(a => a.id).includes(modeReglement.id);
      });
    },
    getFilteredModeReglementTags(text) {
      this.getModeReglementTag();
      this.modeReglementTags = this.modeReglementTags.filter((modeReglement) => {
        return modeReglement.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
  },
  async mounted() {
    if (this.isFromClient) {
      const clientPayeurId = this.$route.params.id;
      this.clientPayeur = (await getClient(clientPayeurId)).data.result;
    }
    this.initializeFiltre();
  },
};
</script>
